const LEFT_EYE = [33, 160, 158, 133, 153, 144];
const RIGHT_EYE = [362, 385, 387, 263, 373, 380];

const EAR_OPEN = 0.25;
const EAR_CLOSED = 0.2;

function distance(a, b) {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return Math.hypot(dx, dy);
}

export function eyeAspectRatio(landmarks, indices) {
  const points = indices.map((i) => landmarks[i]);
  const vertical = distance(points[1], points[5]) + distance(points[2], points[4]);
  const horizontal = distance(points[0], points[3]) * 2;
  if (!horizontal) return 0;
  return vertical / horizontal;
}

export function averageEar(landmarks) {
  const left = eyeAspectRatio(landmarks, LEFT_EYE);
  const right = eyeAspectRatio(landmarks, RIGHT_EYE);
  return (left + right) / 2;
}

export class BlinkDetector {
  constructor(requiredBlinks = 1) {
    this.requiredBlinks = requiredBlinks;
    this.reset();
  }

  reset() {
    this.blinkCount = 0;
    this.eyesWereClosed = false;
    this.faceDetected = false;
  }

  update(landmarks) {
    if (!landmarks?.length) {
      this.faceDetected = false;
      return this.snapshot();
    }

    this.faceDetected = true;
    const ear = averageEar(landmarks);

    if (ear < EAR_CLOSED) {
      this.eyesWereClosed = true;
    } else if (ear > EAR_OPEN && this.eyesWereClosed) {
      this.blinkCount += 1;
      this.eyesWereClosed = false;
    }

    return this.snapshot();
  }

  snapshot() {
    return {
      blinkCount: this.blinkCount,
      blinkVerified: this.blinkCount >= this.requiredBlinks,
      faceDetected: this.faceDetected,
    };
  }
}
